import { Science } from "@mui/icons-material";
import { useState } from "react";
import theme from "theme";
import ImportDocumentPropertiesDialog from "../../ImportDocumentPropertiesDialog";
import { useAppSelector } from "redux/hooks";
import { selectIsOwnerOrSupport } from "redux/slices/session";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";

const ImportDocumentProperties = (props: { lensId: number }) => {
  const { lensId } = props;
  const [showImportDocumentProperties, setShowImportDocumentProperties] = useState<boolean>(false);
  const isOwnerOrSupport = useAppSelector(selectIsOwnerOrSupport);
  // Typescript requires we return a component or null
  // so we use a ternary to return null if the user is not an owner or support
  return isOwnerOrSupport ? (
    <>
      <ManagementCard
        id="lens-admin-management-import-document-properties"
        title="Import Document Properties"
        onClick={() => setShowImportDocumentProperties(true)}
        Icon={Science}
        color={theme.palette.secondary.main}
      />
      {showImportDocumentProperties && (
        <ImportDocumentPropertiesDialog setOpen={setShowImportDocumentProperties} lensId={lensId} />
      )}
    </>
  ) : null;
};

export default ImportDocumentProperties;
